import { WhatsNewArticle } from "../types/whatsNew.types";
import { GrowthRepo } from "../../../app/growth-block/GrowthRepo";

export class WhatsNewRepository {
  private growthRepo: GrowthRepo;

  constructor() {
    this.growthRepo = new GrowthRepo();
  }

  async fetchAllArticles(): Promise<WhatsNewArticle[]> {
    try {
      return await this.growthRepo.fetchBikFeaturesCustomized();
    } catch (error) {
      throw new Error("Failed to fetch articles");
    }
  }

  async createArticle(
    articleData: Omit<WhatsNewArticle, "docId">
  ): Promise<void> {
    try {
      await this.growthRepo.createOrUpdateArticleDocument(articleData);
    } catch (error) {
      throw new Error("Failed to create article");
    }
  }

  async updateArticle(
    documentId: string,
    articleData: Partial<WhatsNewArticle>
  ): Promise<void> {
    try {
      await this.growthRepo.createOrUpdateArticleDocument(
        articleData,
        documentId
      );
    } catch (error) {
      throw new Error("Failed to update article");
    }
  }

  async deleteArticle(documentId: string): Promise<void> {
    try {
      await this.growthRepo.deleteArticleDocument(documentId);
    } catch (error) {
      throw new Error("Failed to delete article");
    }
  }

  async archiveArticle(documentId: string, archive?: boolean): Promise<void> {
    try {
      await this.growthRepo.archiveArticleDocument(documentId, archive);
    } catch (error) {
      throw new Error("Failed to archive article");
    }
  }

  async updateArticleVisibility(
    documentId: string,
    visibility: boolean
  ): Promise<void> {
    try {
      await this.growthRepo.updateArticleVisibility(documentId, visibility);
    } catch (error) {
      throw new Error("Failed to update article visibility");
    }
  }
}
